import { Form, Tag } from 'antd';
import useFormInstance from 'antd/lib/form/hooks/useFormInstance';
import { Input } from 'common/components';
import { actionPropsByAction } from 'features/upload/helpers';
import { getMyEvidence } from 'features/upload/selectors/uploadSelectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as S from '../shared/styles';

type Props = {
    name: string;
};

export const BenefitValueSuggestionCard = ({ name }: Props) => {
    const benefitValue = Form.useWatch('benefitValue');
    const myEvidence = useSelector(getMyEvidence);
    const initialValue = myEvidence?.benefitChangeSuggestions?.benefitValue;
    const isUpdated = benefitValue !== initialValue;
    const action = isUpdated ? (initialValue ? 'update' : 'create') : '';
    const actionProps = action && actionPropsByAction[action];
    const displayChange = actionProps && (action !== 'update' || isUpdated);

    return (
        <S.SuggestionWrapper color={actionProps && actionProps.color}>
            {displayChange && (
                <S.ChangeInfo>
                    <Tag color={actionProps.color}>
                        {actionProps.label}
                        {isUpdated && (
                            <span>
                                {action === 'update' && `, previous Value: "${initialValue}"`}
                            </span>
                        )}
                    </Tag>
                </S.ChangeInfo>
            )}
            <Form.Item name={name}>
                <Input name={name} type="number" label={'Benefit Value'} required={false} />
            </Form.Item>
        </S.SuggestionWrapper>
    );
};
